<template>
  <button
    class="title btn select-none whitespace-nowrap border capitalize duration-300"
    :class="[{'selected': selected}, 'unselected']"
  >
    {{ ambition?.title }}
  </button>
</template>

<script setup lang="ts">
import type {AmbitionQuery} from '~/graphql/graphql';

const props = defineProps<{
  ambition: AmbitionQuery['ambition']
  selected: boolean
}>();

const color = computed(() => props.ambition?.color);
</script>

<style scoped>
  .unselected {
    --color: v-bind(color);

    /* stylelint-disable-next-line function-no-unknown */
    color: var(--color, theme('colors.blue.DEFAULT'));
  }

  .selected {
    --bg: v-bind(color);

    @apply text-white;
    /* stylelint-disable-next-line function-no-unknown */
    background: var(--bg, theme('colors.blue.DEFAULT'));
  }
</style>
